import React, { useMemo } from "react";
import runeTipsData from "./rune-tips.js";
import { getRiotAssetsContext } from "@outplayed/riot-assets";
import { useGenerateParsedText } from "./rune-guide-helpers";

const RuneOverview = (props) => {
  const { getRuneImg, getRuneJSON } = getRiotAssetsContext();
  const { riotRunes, seoNames, perkStyle, isPrimary, activePerks, championId, role } = props;
  const runeJSON = getRuneJSON(perkStyle, { optionalData: riotRunes });
  const availableRunes = useMemo(() => {
    const path = riotRunes.find((tree) => tree.id === perkStyle);
    const allRunes = path.slots.reduce((acc, curr) => {
      return [...acc, ...curr.runes];
    }, []);
    return allRunes.map((rune) => rune.id);
  }, [perkStyle]);
  const generateParsedText = useGenerateParsedText();

  const getTipItems = () => {
    return activePerks.map((rune, index) => {
      if (!availableRunes.includes(rune) || !runeTipsData["runes"][rune]) {
        return null;
      }

      const text = generateParsedText(runeTipsData["runes"][rune]["text"], { allKeystones: props.allKeystones, seoNames, role });
      return (
        <div key={index} className="tip-item">
          {text}
        </div>
      );
    });
  };

  return (
    <div className="rune-overview">
      <div className="content-section_header">
        <div className="perkstyle-image">
          <img src={getRuneImg(perkStyle, { optionalData: riotRunes })} alt={runeJSON.name} />
        </div>
        <strong>{`${runeJSON.name}:`}</strong>&nbsp;
        <span>{isPrimary ? "Primary" : "Secondary"}</span>
      </div>
      <div>{getTipItems()}</div>
    </div>
  );
};

export default RuneOverview;
